import { createModelSchema, primitive, list, object } from 'serializr';
import { observable, computed, makeObservable } from 'mobx';
import uuid from 'uuid/v4';

import { Geozone } from '@vromo/models';
import { TaskCompleted } from '@vromo/models';

import { optional } from '@vromo/models';

import { TimeFrame } from '@vromo/models';

export type TaskConstraint = 'manual' | 'region' | 'photo' | 'signature';

export class Task {

    _id: string;
    _job: number | null = null;
    id: number | null = null;
    created: number | null = null;
    ix: number | null = null;
    zone: Geozone | null = null;
    completed?: TaskCompleted;
    timeframe: TimeFrame | null = null;
    constraints: Array<TaskConstraint> = [];

    get isComplete(): boolean {
        return this.completed?.time != null;
    }

    constructor() {
        makeObservable(this, {
            ix: observable,
            zone: observable,
            completed: observable,
            timeframe: observable,
            constraints: observable,
            isComplete: computed
        });

        this._id = uuid();
    }
}

createModelSchema(Task, {
    id: optional(primitive()),
    created: optional(primitive()),
    ix: optional(primitive()),
    zone: optional(object(Geozone)),
    completed: optional(object(TaskCompleted)),
    timeframe: object(TimeFrame),
    constraints: list(primitive())
});
